export default {
  "otherRevenu.name": "名前",
  "otherRevenu.billShows": "帳票表示区分",
  "otherRevenu.goodsCode": "品目コード",
  "otherRevenu.detail": "詳細/摘要",
  "otherRevenu.inventory": "数量",
  "otherRevenu.unit": "単位",
  "otherRevenu.taxRate": "消費税率",
  "otherRevenu.status": "ステータス",
  "otherRevenu.title": "その他営業収入作成/編集",
  "otherRevenu.detail.title": "その他営業収入詳細",
  "otherRevenu.accountingRules": "会計ルール（仕訳連携用）",
};